﻿import buttonLoader from '../utilities/buttonLoader.js';

var login = {};

login = {

  init: function () {
    var me = this;

    var loginForm = document.getElementsByClassName('login__form')[0];
    var loginDialogs = document.getElementsByClassName('loginDialog');
    var register = document.querySelector('.register');
    var loginnew = document.querySelector('.loginnew');

    if (loginForm) {
      me.bind(loginForm);
    }
    if (loginDialogs) {
      me.bindLoginDialogs(loginDialogs);
    }

    if (register && loginnew) {
      register.addEventListener('click',
        e => {
          register.classList.add('register--show');
          loginnew.classList.add('loginnew--hide');

          var registerContainer = register.querySelector('.register__container');

          var loginnewContainer = loginnew.querySelector('.loginnew__container');
          registerContainer.classList.add('register__container--show');
          loginnewContainer.classList.add('loginnew__container--hide');
        });
    }

  },
  bindLoginDialogs: function (forms) {
    var me = this;
    Array.prototype.forEach.call(forms, (form) => {
      form.addEventListener("submit", loginDialogOnSubmit, false)
      function loginDialogOnSubmit(e) {
        e.preventDefault();
        me.submit(form);
        form.removeEventListener("submit", loginDialogOnSubmit, false)
      }
    });
  },
  bind: function (form) {
    var me = this;

    const openLoginButton = document.querySelector('.js-open-login-form');

    if (openLoginButton) {

      openLoginButton.addEventListener('click',
        e => {
          document.querySelector('.login__buttons').classList.add('hide');
          document.querySelector('.login__content').classList.remove('hide');
        });

    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var m = form.querySelector('.alert');

      if (m) {
        m.remove();
      }

      me.submit(form);

    });
  },

  submit: function (form) {
    var me = this;

    var button = form.querySelector('button[type=submit]');
    button.classList.add("button--disabled")

    const buttonText = button.querySelector('.button__text')
    if (buttonText) {
      buttonText.style.visibility = "hidden"
    }

    const spinner = button.querySelector('.spinner')
    if (spinner) {
      spinner.classList.remove('hide')
      spinner.style.display = "flex";
    }

    var data = new FormData(form);

    var xhr = new XMLHttpRequest();
    xhr.open(form.getAttribute("method"), form.getAttribute("action"));

    xhr.onload = function () {

      var resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {

        if (resp.success) {
          if (window.location.href.indexOf("minar-sidur") > -1)
            window.location.reload();

        } else {

          buttonLoader.reset(button);
          spinner.classList.add('hide')
          buttonText.style.visibility = "visible"
          button.classList.remove("button--disabled")

          me.renderMessage(button, resp.message, 'error');
        }

      } else {

        buttonLoader.reset(button);

        me.renderMessage(button, 'Server error', 'error');
      }

    };

    xhr.send(data);
  },

  renderMessage: function (el, message, type) {
    el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');

  }

};

login.initialize = function () {
  login.init();
};

module.exports = login;
